module.exports = __webpack_public_path__ + "img/img-01.de34696b.png";